import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';

import { ReactElement } from 'react';
import { ComplexLayoutProps } from '@localstack/types';

type LayoutContainerProps = Pick<ComplexLayoutProps, 'children' | 'fullScreen' | 'maxWidth' | 'flushContent'>;

const ContentContainer = styled(Container, {
  shouldForwardProp: (prop) => prop !== 'flushContent',
})<{ flushContent?: boolean }>(({ theme, flushContent }) => ({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  ...(flushContent
    ? { marginTop: theme.spacing(-3) }
    : { paddingTop: theme.spacing(2), paddingBottom: theme.spacing(11) }),
}));

/**
 * Layout Container is a wrapper with the content to be shown by a given page of the Console. It leverages mui Container component to center our content on larger screen sizes.
 */
export const LayoutContainer = ({
  children,
  fullScreen,
  maxWidth,
  flushContent,
}: LayoutContainerProps): ReactElement => {
  const containerMaxWidth = fullScreen ? false : maxWidth;

  return (
    <ContentContainer maxWidth={containerMaxWidth} disableGutters={flushContent} flushContent={flushContent}>
      {children}
    </ContentContainer>
  );
};
